<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar />
    <PageHero image="cr-hero.jpg">
      <TextHeading variant="subtitle">About Us</TextHeading>
      <TextHeading
        variant="lg"
        block
      >From Bradford market stall to the UK’s 4th largest supermarket chain</TextHeading>
      <BaseButton class="mt-10 text-primary" rounded="full" variant="white" width="small">
        <BaseIcon name="arrow_downward" size="22"></BaseIcon>
      </BaseButton>
    </PageHero>
    <PageGrid>
      <PageMain>
        <PageSection>
          <Cards>
            <CardsCol>
              <CardLink title="Leadership" link="Meet the board" category="Announcements"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink title="Learn more about our history key milestones" category="History"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Vist our section dedicated to investors"
                category="Shareholder Services"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection title="Latest News">
          <Cards>
            <CardsCol>
              <CardArticle
                title="We are proud of all our fresh fish and seafood sold in our stores and café."
                image="carrier-bags.jpg"
                date="01 Jan 2019"
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="man-fish.jpg"
                date="12 Dec 2018"
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="farmer.jpg"
                date="30 Aug 2018"
              />
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import PageHero from '../components/PageHero.vue'
import CardsCol from '../elements/CardsCol.vue'
import CardArticle from '../components/CardArticle.vue'
import TheFooter from '../components/TheFooter.vue'
import CardLink from '../components/CardLink.vue'
import Cards from '../elements/Cards.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'

export default {
  name: 'app',
  components: {
    TheHeader,
    BreadcrumbBar,
    TextHeading,
    PageGrid,
    PageMain,
    PageSection,
    Cards,
    CardLink,
    TheFooter,
    CardArticle,
    CardsCol,
    PageHero,
    BaseButton,
    BaseIcon
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>